import { SvgIcon } from '../SvgIcon';
import * as React from 'react';

interface IProps {
	className?: string;
}

export const MaxioLinkIcon: React.FC<IProps> = props => {
	const { className } = props;

	return (
		<SvgIcon className={`maxio-link-icon ${className || ''}`} height={40} width={194} fill='none'>
			<path
				d='M178.946 4.40289C170.321 4.40289 163.892 11.0984 163.892 20.0453C163.892 28.8322 170.321 35.5243 178.946 35.5243C187.624 35.5243 194 28.8287 194 20.0453C194 11.0451 187.518 4.40289 178.946 4.40289ZM178.946 32.5282C172.035 32.5282 167.106 27.2774 167.106 20.0453C167.106 12.4915 172.035 7.34906 178.946 7.34906C185.803 7.34906 190.786 12.4915 190.786 20.0453C190.786 27.2774 185.803 32.5282 178.946 32.5282Z'
				fill='black'
			/>
			<path d='M157.946 4.99283H154.838V34.7778H157.946V4.99283Z' fill='black' />
			<path
				d='M148.089 7.02918L145.731 4.99283L135.016 17.3674H134.16L123.392 4.99283L121.089 7.02918L132.017 19.4571V20.3669L121.089 32.6899L123.392 34.7779L134.16 22.5099H135.016L145.571 34.7779L147.928 32.7965L137.159 20.3669V19.4571L148.089 7.02918Z'
				fill='black'
			/>
			<path
				d='M103.517 4.99307L92.0537 34.7781H95.2682L97.9598 27.7162L99.9566 26.0995H110.642L112.362 27.5494L115.085 34.7729H118.461L107.049 4.98792L103.517 4.99307ZM100.024 22.3141L104.808 9.75888H105.668L110.45 22.4431L109.794 23.0983H100.851L100.024 22.3141Z'
				fill='black'
			/>
			<path
				d='M71.8568 31.0818H70.9985L60.9819 4.9928H55.5178V34.7778H58.6239V9.76033H59.4822L69.1772 34.7778H73.6781L83.1599 9.76033H84.0164V34.7778H87.1242V4.9928H81.6601L71.8568 31.0818Z'
				fill='black'
			/>
			<path
				d='M11.7056 0L9.83088 1.87468L15.8299 7.82205V12.8579L15.2141 13.4203L6.72304 4.98251L4.90168 6.80388L13.3395 15.295L12.8304 15.8574H7.84785L1.84888 9.85668L0 11.7056L6.77636 18.4819H18.4561V6.69724L11.7056 0Z'
				fill='black'
			/>
			<path
				d='M28.0666 0L29.9413 1.87468L23.9423 7.82205V12.8579L24.558 13.4203L33.0491 4.98251L34.8705 6.80388L26.4327 15.295L26.9418 15.8574H31.9243L37.9233 9.85668L39.7722 11.7056L32.9958 18.4819H21.316V6.69724L28.0666 0Z'
				fill='black'
			/>
			<path
				d='M11.7056 39.8378L9.83088 37.9631L15.8299 32.0157V26.9799L15.2141 26.4175L6.72304 34.8553L4.90168 33.0339L13.3395 24.5428L12.8304 23.9804H7.84785L1.84888 29.9811L0 28.1322L6.77636 21.3559H18.4561V33.1405L11.7056 39.8378Z'
				fill='black'
			/>
			<path
				d='M28.0666 39.8378L29.9413 37.9632L23.9423 32.0158V26.98L24.558 26.4176L33.0491 34.8553L34.8705 33.034L26.4327 24.5429L26.9418 23.9805H31.9243L37.9233 29.9812L39.7722 28.1323L32.9958 21.3559H21.316V33.1406L28.0666 39.8378Z'
				fill='black'
			/>
		</SvgIcon>
	);
};
